"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _utils = require("../../utils");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _PromptablePropInterface = _interopRequireDefault(require("UIComponents/decorators/PromptablePropInterface"));

var _connectCommunicationMethods = _interopRequireDefault(require("ui-addon-upgrades/_core/communicationMethods/connectCommunicationMethods"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var CommunicationMethodsModal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CommunicationMethodsModal, _React$Component);

  function CommunicationMethodsModal() {
    (0, _classCallCheck2.default)(this, CommunicationMethodsModal);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CommunicationMethodsModal).apply(this, arguments));
  }

  (0, _createClass2.default)(CommunicationMethodsModal, [{
    key: "renderCommunicator",
    value: function renderCommunicator() {
      var _this$props = this.props,
          selectedMethodComponent = _this$props.selectedMethodComponent,
          buttonComponents = _this$props.buttonComponents,
          _overrideModalHeaderText = _this$props._overrideModalHeaderText;

      if (selectedMethodComponent) {
        return _react.default.createElement("div", null, selectedMethodComponent);
      }

      return _react.default.createElement("div", null, _react.default.createElement("h1", {
        className: "m-bottom-8"
      }, _overrideModalHeaderText || _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.communicationMethods.title"
      })), _react.default.createElement(_UIFlex.default, {
        justify: "center"
      }, buttonComponents ? _react.default.createElement("div", null, _react.default.createElement(_UIFlex.default, {
        justify: "center",
        style: {
          width: '100%'
        }
      }, buttonComponents), _react.default.createElement("div", {
        className: "text-left m-top-9"
      }, _react.default.createElement("h6", null, _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.communicationMethods.footer.header"
      })), _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.communicationMethods.footer.body"
      })))) : _react.default.createElement(_UILoadingSpinner.default, null)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onReject = _this$props2.onReject,
          onCancel = _this$props2.onCancel,
          buttonComponents = _this$props2.buttonComponents;
      var propsToPass = (0, _utils.omit)(this.props, ['onReject', 'onConfirm', 'upgradeData', 'buttonComponents', 'selectedMethodComponent', 'upgradeComponent', '_overrideModalHeaderText']);
      return _react.default.createElement(_UIModal.default, (0, _extends2.default)({
        width: 550 + (buttonComponents ? buttonComponents.length - 2 : 0) * 100,
        use: "conversational"
      }, propsToPass, {
        "data-test-id": "tts-modal"
      }), _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_UIDialogCloseButton.default, {
        onClick: function onClick() {
          onReject();
          onCancel();
        }
      })), _react.default.createElement(_UIDialogBody.default, {
        className: "p-bottom-10"
      }, this.renderCommunicator()));
    }
  }]);
  return CommunicationMethodsModal;
}(_react.default.Component);

CommunicationMethodsModal.propTypes = (0, _extends2.default)({}, _PromptablePropInterface.default, {
  buttonComponents: _propTypes.default.array,
  selectedMethodComponent: _propTypes.default.node,
  upgradeComponent: _propTypes.default.node
});

var _default = (0, _connectCommunicationMethods.default)(CommunicationMethodsModal, {
  onDark: false,
  buttonType: 'selectableButton'
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/communicationMethods/CommunicationMethodsModal.js
// module id = 623
// module chunks = 5 6